/** Full class strings per breakpoint so Tailwind JIT can see them. */
export const LAYOUT_BREAKPOINT_CLASSNAMES = {
  sm: {
    sectionGrid: 'sm:grid sm:min-h-0',
    mainCol1: 'sm:col-span-1',
    mainCol2: 'sm:col-span-2',
    mainOverflow: 'sm:min-h-0 sm:overflow-y-auto sm:overflow-x-hidden',
    mainOrder2: 'sm:order-2',
    sidebarShell: 'sm:col-span-1 sm:min-h-0',
    sidebarOrder1: 'sm:order-1',
    cols3: 'sm:grid-cols-3',
    cols1: 'sm:grid-cols-1'
  },
  md: {
    sectionGrid: 'md:grid md:min-h-0',
    mainCol1: 'md:col-span-1',
    mainCol2: 'md:col-span-2',
    mainOverflow: 'md:min-h-0 md:overflow-y-auto md:overflow-x-hidden',
    mainOrder2: 'md:order-2',
    sidebarShell: 'md:col-span-1 md:min-h-0',
    sidebarOrder1: 'md:order-1',
    cols3: 'md:grid-cols-3',
    cols1: 'md:grid-cols-1'
  },
  lg: {
    sectionGrid: 'lg:grid lg:min-h-0',
    mainCol1: 'lg:col-span-1',
    mainCol2: 'lg:col-span-2',
    mainOverflow: 'lg:min-h-0 lg:overflow-y-auto lg:overflow-x-hidden',
    mainOrder2: 'lg:order-2',
    sidebarShell: 'lg:col-span-1 lg:min-h-0',
    sidebarOrder1: 'lg:order-1',
    cols3: 'lg:grid-cols-3',
    cols1: 'lg:grid-cols-1'
  },
  xl: {
    sectionGrid: 'xl:grid xl:min-h-0',
    mainCol1: 'xl:col-span-1',
    mainCol2: 'xl:col-span-2',
    mainOverflow: 'xl:min-h-0 xl:overflow-y-auto xl:overflow-x-hidden',
    mainOrder2: 'xl:order-2',
    sidebarShell: 'xl:col-span-1 xl:min-h-0',
    sidebarOrder1: 'xl:order-1',
    cols3: 'xl:grid-cols-3',
    cols1: 'xl:grid-cols-1'
  },
  '2xl': {
    sectionGrid: '2xl:grid 2xl:min-h-0',
    mainCol1: '2xl:col-span-1',
    mainCol2: '2xl:col-span-2',
    mainOverflow: '2xl:min-h-0 2xl:overflow-y-auto 2xl:overflow-x-hidden',
    mainOrder2: '2xl:order-2',
    sidebarShell: '2xl:col-span-1 2xl:min-h-0',
    sidebarOrder1: '2xl:order-1',
    cols3: '2xl:grid-cols-3',
    cols1: '2xl:grid-cols-1'
  }
};

export const LAYOUT_BREAKPOINT_KEYS = Object.keys(LAYOUT_BREAKPOINT_CLASSNAMES);
